import { FunctionComponent, memo } from 'react';
import { FeedCardProps, FeedCardThreadCommon } from '../../../shared';

export const FeedCardAdminThread: FunctionComponent<FeedCardProps> = memo(({ card }) => {
  return <FeedCardThreadCommon card={card} />;
});
